/* eslint-disable no-undef */

try {
  (($) => {
    $(document.body).on("update_checkout", function () {
      const hasShippingMyParcel = $(".myparcel-delivery-options__table").is(
        ":visible"
      );

      const isLogin = $("form.checkout.woocommerce-checkout").hasClass(
        "logged_in"
      );

      if (isLogin) {
        if (!hasShippingMyParcel) {
          $("#place_order").attr("type", "button");
          $("#place_order").attr("disabled", true);
          $("#checkout-error-message").html(
            $("#checkout-error-message").data("errormessage")
          );
        } else {
          $("#place_order").attr("type", "submit");
          $("#place_order").attr("disabled", false);
          $("#checkout-error-message").html(" ");
        }
      }
    });
  })(jQuery);
} catch (error) {
  // eslint-disable-next-line no-console
  console.log("checkout-if-login", error);
}
